import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';
import { AppSettings } from 'src/app/app.settings';
import { MarketingArchiveStatusFilter } from '../../interfaces/campaigns/campaign.interface';
import {
  MarketingSequence,
  PostMarketingSequence,
} from '../../interfaces/campaigns/sequence.interface';

@Injectable({
  providedIn: 'root',
})
export class MarketingSequencesService {
  constructor(
    private baseRestAngular: ApiClient,
    private restAngular: ApiClient,
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withBaseUrl(AppSettings.getMarketingEndpoint());
  }

  create(data: PostMarketingSequence): Promise<MarketingSequence> {
    return this.restAngular.one('sequences').customPOST(data).toPromise();
  }

  getAll(status: MarketingArchiveStatusFilter = 'active'): Promise<MarketingSequence[]> {
    return this.restAngular.all('sequences').getList({ status }).toPromise();
  }

  updateById(id: string, data: PostMarketingSequence): Promise<MarketingSequence> {
    return this.restAngular.one('sequences', id).customPUT(data).toPromise();
  }

  archiveById(id: string): Promise<void> {
    return this.restAngular.one('sequences', id).remove().toPromise();
  }
}
